/**
 * The newsfeed's deep link, kept out of the page component for the same reason
 * the knowledge base's `sections.ts` is: the command palette links at the
 * sources, and it has no business importing a route component to do it.
 *
 * The hash no longer names a section of the page — there is none, since the
 * sources are managed in the Edit feed dialog and nowhere else. `/news` reads
 * it as an instruction: open that dialog on the tab that lists what is
 * followed. The constants keep their names because the link is the same link.
 */

/** The hash `/news` opens the Edit feed dialog on. */
export const NEWS_SOURCES_ANCHOR = 'sources';

/** Deep link to managing sources: `/news#sources`, i.e. the Edit feed dialog. */
export const NEWS_SOURCES_PATH = `/news#${NEWS_SOURCES_ANCHOR}`;
